import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LabelPrintConfig } from 'src/app/models/auxiliary/label-print-config.model';
import { DoctorLabelPrint } from 'src/app/models/doctor/doctor-label-print.model';
import { LabelPrintConfigService } from 'src/app/sections/auxillary-tables/label-print-configuration/services/label-print-config.service';
import { CommonDataService } from 'src/app/sections/common/services/common-data.service';

@Component({
  selector: 'app-label-print',
  templateUrl: './label-print.component.html',
  styleUrls: ['./label-print.component.scss']
})
export class LabelPrintComponent implements OnInit, OnChanges {
  @Input() reportId: string;
  @Input() data: any;
  
  labelPrintConfig: LabelPrintConfig;
  doctorLabelPrintList: DoctorLabelPrint[] = [];

  constructor(public commonDataService: CommonDataService,  private _labelPrintConfigService: LabelPrintConfigService,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this.loadLabelPrintConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.doctorLabelPrintList = this.data;
      this.cdr.detectChanges();
    }
  }

  loadLabelPrintConfig() {
    this._labelPrintConfigService.getLabelPrintConfigList()
      .subscribe(
        (data: any) => {
          if (data._data != null && data._data.length > 0) {
            this.labelPrintConfig = data._data[0];
          }
        },
        (error) => {
        }
      );
  }

  formatAddressLine1(label: any): string {
    return [label.mailingNameOfVia, label.mailingNumber, label.mailingDoor]
      .filter(val => !!val)
      .join(', ');
  }

  formatAddressLine2(label: any): string {
    return [label.mailingPostalCode, label.townName]
      .filter(val => !!val)
      .join(', ');
  }


}
